import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconPlus = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconPlus.dimensions.width} ${IconPlus.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M.987 12.556h21.466a.987.987 0 000-1.973H.987a.987.987 0 000 1.973z" />
        <Path d="M12.707 22.453V.987a.987.987 0 00-1.974 0v21.466a.987.987 0 001.973 0z" />
      </G>
    </Svg>
  )
}

IconPlus.dimensions = {
  width: 23.439,
  height: 23.439,
}

export default IconPlus
